import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

$(function () {
  const $countrySwitcher = $('.country-switcher');
  const $countrySwitcherModal = $('.country-switcher__modal');
  const $countrySwitcherSelector = $('.country-switcher__modal__country');
  const $languageSwitcherSelector = $('.country-switcher__modal__language');
  const $countrySwitcherSelectorOpener = $('.country-switcher__modal__country__selected');
  const $languageSwitcherSelectorOpener = $('.country-switcher__modal__language__selected');

  if (!$countrySwitcher.length || !$countrySwitcherModal.length) return;

  if ($countrySwitcherSelector.length > 0 && $countrySwitcherSelectorOpener.length > 0) {
    $countrySwitcherSelectorOpener.on('click', function () {
      $countrySwitcherSelector.toggleClass('open');
      if ($languageSwitcherSelector.length > 0 && $languageSwitcherSelector.hasClass('open')) {
        $languageSwitcherSelector.removeClass('open');
      }
    });
  }

  if ($languageSwitcherSelector.length > 0 && $languageSwitcherSelectorOpener.length > 0) {
    $languageSwitcherSelectorOpener.on('click', function () {
      $languageSwitcherSelector.toggleClass('open');
      if ($countrySwitcherSelector.length > 0 && $countrySwitcherSelector.hasClass('open')) {
        $countrySwitcherSelector.removeClass('open');
      }
    });
  }

  const $countrySwitcherModalClose = $('.country-switcher__modal__close');

  $countrySwitcher.on('click', function () {
    $countrySwitcherModal.addClass('open');
    $('body').addClass('country-lang-open');

    atQuery('min', 'md', () => {
      showBackdrop();
    });
  });

  const $activeCountry = $countrySwitcher.find('.country-switcher__active-country');
  if ($activeCountry.length <= 0) return;

  $activeCountry.on('blur', function (e) {
    if (!e.relatedTarget || !e.relatedTarget.closest('.country-switcher__dropdown')) {
      $countrySwitcher.removeClass('open');
    }
  });

  $($countrySwitcherModalClose).on('click', function(e) {
    e.stopPropagation();
    $countrySwitcherModal.removeClass('open');
    $('body').removeClass('country-lang-open');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });
  });
});
